import FormTextarea from "../../../../../../packages/design-system/src/FormTextarea";
import { CustomFormTextarea } from "../../../../../../packages/design-system/src/FormTextarea/readme-helpers";
import Spacings from "../../../../../../packages/design-system/src/Spacings";
import * as React from 'react';
export default {
  FormTextarea,
  CustomFormTextarea,
  Spacings,
  React
};